<template>
  <div
    class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-text-center"
    data-testid="locked-drawer-empty-state"
  >
    <img
      :src="$imagesRequire('empty_states/report-charts.svg')"
      alt=""
      class="tw-w-32 tw-h-32 tw-object-contain"
    />
    <p class="tw-m-0 tw-text-base tw-font-bold tw-text-sf-slate-dark-1">
      {{ I18n.t('report.drawer.locked_empty_state.title') }}
    </p>
    <p class="tw-m-0 tw-max-w-[260px] tw-text-sm tw-text-sf-slate-light-1">
      {{ I18n.t('report.drawer.locked_empty_state.body') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'

defineOptions({
  name: 'LockedDrawerEmptyState',
})

const I18n = useI18n()
</script>
